module.exports = __webpack_public_path__ + "img/2022_09_dandelion_kamigamoshrine_fin_web.8414ce6a.jpg";